import React, { useState, createContext, useContext } from "react";
import {
  ITripDateRange,
  defaultFavoriteDateRange,
  defaultPastDateRange,
  defaultUpcomingDateRange,
} from "../types/TripTypes";
import {
  Tabs,
  defaultCurrentPage,
  defaultForceRefetch,
  defaultPageSize,
  defaultRowsToSkip,
  defaultSortOrder,
  defaultTripTypes,
} from "../types/TripPaginationFilterTypes";

export const PaginationContext = createContext<any | undefined>(undefined);

export const usePaginationCtx = () => useContext(PaginationContext);

export const PaginationProvider: React.FC = ({ children }) => {
  const [activeTab, setActiveTab] = useState<string>(Tabs.UPCOMING);
  const [pageSize, setPageSize] = useState<{ [tab: string]: number }>(
    defaultPageSize
  );
  const [currentPage, setCurrentPage] = useState<{ [tab: string]: number }>(
    defaultCurrentPage
  );
  const [rowsToSkip, setRowsToSkip] = useState<{ [tab: string]: number }>(
    defaultRowsToSkip
  );
  const [sortOrder, setSortOrder] = useState<{ [tab: string]: string }>(
    defaultSortOrder
  );

  const [tripTypes, setTripTypes] = useState<{
    [tab: string]: Set<string>;
  }>(defaultTripTypes);
  const [upcomingDateRange, setUpcomingDateRange] = useState<ITripDateRange>(
    defaultUpcomingDateRange
  );
  const [pastDateRange, setPastDateRange] = useState<ITripDateRange>(
    defaultPastDateRange
  );
  const [selectedUpcomingPersonId, setSelectedUpcomingPersonId] = useState<
    string
  >("");
  const [selectedPastPersonId, setSelectedPastPersonId] = useState<string>("");
  const [favoriteDateRange, setFavoriteDateRange] = useState<ITripDateRange>(
    defaultFavoriteDateRange
  );
  const [showCanceled, setShowCanceled] = useState<boolean>(false);
  const [forceRefetch, setForceRefetch] = useState<{ [tab: string]: boolean }>(
    defaultForceRefetch
  );

  const resetFavoritePagination = () => {
    setRowsToSkip((prev) => ({
      ...prev,
      [Tabs.FAVORITE]: 0,
    }));
    setCurrentPage((prev) => ({
      ...prev,
      [Tabs.FAVORITE]: 1,
    }));
    setForceRefetch((prev) => ({
      ...prev,
      [Tabs.FAVORITE]: !prev[Tabs.FAVORITE],
    }));
  };

  const resetPagination = () => {
    setSelectedUpcomingPersonId("");
    setTripTypes(defaultTripTypes);
    setSelectedPastPersonId("");
    setActiveTab(Tabs.UPCOMING);
    setShowCanceled(false);
    setPastDateRange(defaultPastDateRange);
    setRowsToSkip(defaultRowsToSkip);
    setPageSize(defaultPageSize);
    setCurrentPage(defaultCurrentPage);
    setSortOrder(defaultSortOrder);
    setUpcomingDateRange(defaultUpcomingDateRange);
  };

  return (
    <PaginationContext.Provider
      value={{
        resetPagination,
        resetFavoritePagination,
        selectedUpcomingPersonIdCtx: [
          selectedUpcomingPersonId,
          setSelectedUpcomingPersonId,
        ],
        selectedPastPersonIdCtx: [
          selectedPastPersonId,
          setSelectedPastPersonId,
        ],
        forceRefetchCtx: [forceRefetch, setForceRefetch],
        pageSizeCtx: [pageSize, setPageSize],
        activeTabCtx: [activeTab, setActiveTab],
        sortOrderCtx: [sortOrder, setSortOrder],
        tripTypesCtx: [tripTypes, setTripTypes],
        rowsToSkipCtx: [rowsToSkip, setRowsToSkip],
        currentPageCtx: [currentPage, setCurrentPage],
        showCanceledCtx: [showCanceled, setShowCanceled],
        pastDateRangeCtx: [pastDateRange, setPastDateRange],
        upcomingDateRangeCtx: [upcomingDateRange, setUpcomingDateRange],
        favoriteDateRangeCtx: [favoriteDateRange, setFavoriteDateRange],
      }}
    >
      {children}
    </PaginationContext.Provider>
  );
};
